import {
  post
} from '../axios'

class Sms {
  async sendApproveMessage(data,param) {
    const res = await post('/Sms/SendApproveMessgae',data,param)
    return res
  }
  async sendClueMail(data,param) {
    const res = await post('/Sms/SendClueMail',data,param)
    return res
  }
}
export default new Sms()